import { useContext, useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Calendar } from 'primereact/calendar';
import { classNames } from "primereact/utils";

import NoInfo from "../../components/NoInfo";

import { FormInput } from '../../components/FormInput';
import { addDate, checkDpSuccess, getFormErrorMessage, getMaskedString, setformate } from "../../utility/service/tool-service";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useFuncId } from '../../router/menuRouterMapper';
import { checkLoading, SystemLoading } from '../../store/loadingStore';
import { handleSuccessMessage, MessageContext } from '../../store/messageStore';
import { getAuditLogMList, updateAuditEyesEvent } from '../../utility/service/audilog-service';

const AccountActivityIndex = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear() + 10;
    const currentMinGuoYear = new Date().getFullYear() - 1911 + 10;
    const [currentDate, setCurrentDate] = useState('');
    const { setItemObj, setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [reqQueryHeader, setReqQueryHeader] = useState({});
    const [isMore, setIsMore] = useState(false);
    const [tokenValue, setTokenValue] = useState();
    //查看更多參數
    const [auditExtId, setAuditExtId] = useState('');
    const [auditLogId, setAuditLogId] = useState('');

    const [, loading] = useContext(SystemLoading);
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [columns, setColumns] = useState([]);
    const navigate = useNavigate();
    const [maskView,setMaskView] = useState(false);
    const chsFuncId = useFuncId();
    


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        trigger,
        reset: resetForm,
        control,
        reset,
        formState: { errors, isValid, isDirty }
    } = useForm({
        defaultValues: {
            startDate: '',//起
            endDate: '',
            keywords: ''
        },
        //錯誤驗證時機
        mode: "all"
    });



    //查詢更多
    const btnReadMore = () => {
        if (columns?.length === 0) {
            return
        } else {
            setCurrentStatus({})
            setIsMore(true);
            setReqQueryHeader(setReqBody(true));
        }


    }



    const axios_getAuditLogMList = useMemo(() => (reqHeader, readMore = false) => {
        checkLoading(loading);

        getAuditLogMList(reqHeader).then(res => {
            if (checkDpSuccess(res)) {
                setAuditExtId(res.data.RespBody.dataList[res.data.RespBody.dataList.length - 1].auditExtId)
                setAuditLogId(res.data.RespBody.dataList[res.data.RespBody.dataList.length - 1].auditLongId)
                if (readMore === true) {

                    setColumns((pre) => {
                        return [...pre, ...res.data.RespBody.dataList]
                    });

                } else {
                    setColumns(res.data.RespBody.dataList)

                }
            } else if (res?.data?.ResHeader?.rtnCode === '1298') {
                if (readMore === false) {
                    setColumns((pre) => {
                        return []
                    })
                }
            }
        })
        .finally(() => checkLoading(loading, false))
    }, []);

    useEffect(() => {
        if (JSON.stringify(currentStatus) === '{}' && JSON.stringify(reqQueryHeader) !== '{}') { //抓取新資料
            axios_getAuditLogMList(reqQueryHeader, isMore);
        } else { //點擊返回上一頁將原本資料帶入
            if (currentStatus.dataList) {
                setColumns((pre) => {
                    return [...currentStatus.dataList]
                });
                setAuditExtId(currentStatus.dataList[currentStatus.dataList.length - 1].auditExtId);
                setAuditLogId(currentStatus.dataList[currentStatus.dataList.length - 1].auditLongId);
                setValue("startDate", currentStatus.startDate, { shouldValidate: true });
                setValue("endDate", currentStatus.endDate, { shouldValidate: true });
            }


        }
    }, [reqQueryHeader, axios_getAuditLogMList, currentStatus]);

    useEffect(() => {
        initDate();
    }, [])

    function initDate() {

        let date = new Date();
        let SDate = setformate(addDate(date, -6), "YYYY-MM-DD");
        let EDate = setformate(date, "YYYY-MM-DD");
        setValue("startDate", new Date(SDate), { shouldValidate: true });
        setValue("endDate", new Date(EDate), { shouldValidate: true });
        setCurrentDate(setformate(date, "YYYY-MM-DD"));
        setReqQueryHeader(setReqBody(false, SDate, EDate));
    }


    const preMonth = () => {
        setIsMore(false)
        let sDate = new Date(currentDate);
        sDate.setMonth(sDate.getMonth() - 1);
        sDate.setDate(1);
        setValue("startDate", new Date(sDate), { shouldValidate: true });
        let eDate = new Date(getValues("startDate"));
        eDate.setMonth(sDate.getMonth() + 1);
        eDate.setDate(eDate.getDate() - 1);
        setValue("endDate", new Date(eDate), { shouldValidate: true });
        clearErrors(["startDate", "endDate"]);
        setCurrentDate((pre) => {
            let date = new Date(pre);
            date = setformate(date.setMonth(date.getMonth() - 1), "YYYY-MM-DD");
            return date
        })

        setReqQueryHeader(setReqBody(false));
    }

    const nextMonth = () => {
        setIsMore(false)
        let sDate = new Date(currentDate);
        sDate.setMonth(sDate.getMonth() + 1);
        sDate.setDate(1);
        setValue("startDate", new Date(sDate), { shouldValidate: true });
        let eDate = new Date(getValues("startDate"));
        eDate.setMonth(sDate.getMonth() + 1);
        eDate.setDate(eDate.getDate() - 1);
        setValue("endDate", new Date(eDate), { shouldValidate: true });
        clearErrors(["startDate", "endDate"]);
        setCurrentDate((pre) => {
            let date = new Date(pre);
            date = setformate(date.setMonth(date.getMonth() + 1), "YYYY-MM-DD");
            return date
            // return pre.setMonth(pre.getMonth() + 1);
        })
        setReqQueryHeader(setReqBody(false));
    }

    const setReqBody = (isMore = false, sDate = '', eDate = '') => {
        let reqBody = {};
        reqBody = {
            endDate: setformate(eDate !== '' ? eDate : getValues("endDate"), "YYYY/MM/DD"),
            startDate: setformate(sDate !== '' ? sDate : getValues("startDate"), "YYYY/MM/DD"),
            keywords: getValues("keywords")
        }
        if (isMore === true) {
            reqBody.auditExtId = auditExtId;
            reqBody.auditLogId = auditLogId;
        }
        return reqBody;
    }

    const onSubmit = (data) => {
        setCurrentStatus({})
        setIsMore(false);
        setReqQueryHeader(setReqBody(false));

    }
    const goItemPage = (data) => {
        setItemObj(data);
        setAction('detail');
        setCurrentStatus({
            dataList: columns,
            startDate: getValues("startDate"),
            endDate: getValues("endDate")
        })
        navigate('detail', { state: { dataList: columns, startDate: getValues("startDate"), endDate: getValues("endDate") } });
    }

    const copyToClipboard = (data) => {
        const textToCopy = data
        navigator.clipboard.writeText(textToCopy)
            .then(() => { handleSuccessMessage(dispatch, t('copy') + ' ' + t('message.success')); })
            .catch((error) => { })
    }
    //多國語系 月份對照
    const monthMapping = [
        {
            month: 'Jan',
            value: '01',
        },
        {
            month: 'Feb',
            value: '02',
        },
        {
            month: 'Mar',
            value: '03',
        },
        {
            month: 'Apr',
            value: '04',
        },
        {
            month: 'May',
            value: '05',
        },
        {
            month: 'Jun',
            value: '06',
        },
        {
            month: 'Jul',
            value: '07',
        },
        {
            month: 'Aug',
            value: '08',
        },
        {
            month: 'Sep',
            value: '09',
        },
        {
            month: 'Oct',
            value: '10',
        },
        {
            month: 'Nov',
            value: '11',
        },
        {
            month: 'Dec',
            value: '12',
        }
    ]

    const mappingMath = (month) => {
        let filterMon = monthMapping?.filter((item) => item.value === month)
        return t(filterMon?.[0]?.month)
    }

    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:"V"
        })
        .then((res)=>{
            if(checkDpSuccess(res)){
    
            }
        })
    }


    return (<>
        {/* 上方查詢區 */}
        <div className="p-card bg-gray">
            <div className="p-card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='grid'>
                        <div className='col-12 lg:col-4'>
                            <label
                                htmlFor="executionDate"
                                className="form-label">
                                {t('action_date')}
                            </label>
                            <div className='custom-moth-picker'>
                                <Button type='button' onClick={() => { preMonth() }} icon="pi pi-angle-left" />
                                <span style={{ display: currentDate == '' ? 'none' : '' }}>
                                    {mappingMath(currentDate.split("-")[1])}
                                </span>
                                <Button type='button' onClick={() => { nextMonth() }} icon="pi pi-angle-right" />
                            </div>
                        </div>
                        <div className='col-12 lg:col-8 flex align-items-end'>
                            <div className="col-date-picker">
                                <Controller
                                    name="startDate"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        // validate: (val) => {
                                        //     if ( ( val!=="" && watch('endDate')!=='' ) && watch('endDate') < val) return t('validation.startDate')
                                        //   }, 
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        <Calendar
                                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                            dateFormat='yy-mm-dd'
                                            value={field.value || ''}
                                            onChange={(e) => {
                                                field.onChange(e.value)
                                                // if(e.value < watch("endDate")){
                                                //     clearErrors("endDate")
                                                // }
                                            }}
                                            showIcon />
                                    )} />
                                {getFormErrorMessage(errors, "startDate")}

                                <Controller
                                    name="endDate"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        // validate: (val) => {
                                        //     if ( (val!=='' && watch('startDate')!=='') && watch('startDate')> val) return t('validation.endDate')
                                        //   },  
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        <Calendar
                                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                            dateFormat='yy-mm-dd'
                                            value={field.value || ''}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                // if(e.value > watch("startDate")){
                                                //     clearErrors("startDate")
                                                // }
                                            }}
                                            showIcon />
                                    )} />
                                {getFormErrorMessage(errors, "endDate")}
                            </div>
                        </div>
                    </div>
                    <div className='grid'>
                        <div className='col-12'>
                            <FormInput
                                register={register}
                                errors={errors}
                                id="keywords"
                                type="text"
                                placeholder={`${t('user_acct')}、${t('user_name')}、${t('api_url')}、${t('api_event')}、${t('user_role')}、${t('params')}`}
                                labelText={t('keyword')}
                            // labelClass="control-label"
                            />
                        </div>
                    </div>
                    <div className="grid">
                        <div className='col-12'>
                            <Button disabled={!isValid} type='submit' label={t('button.query')} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
      
        {/* 下方顯示區 */}
        <div className="p-card">
            <div className="p-card-body">
                <Button
                type="button"
                className="mb-2"
                icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
                severity="secondary"
                disabled={columns?.length===0}
                onClick={() => {
                    setMaskView(prev => {
                        if(!prev){
                          axios_updateAuditEyesEvent();
                        }
                        return !prev;
                      });
                }}
            />
                <div className="double-row-title-table-wrapper">
                    <div className="double-row-title-table">
                        <div className="header">
                            {/* 軌跡編號 */}
                            <div className='space'>{t('audit_id')}</div>
                            {/* 用戶端帳號 */}
                            <div className='space'>ID Token</div>
                            {/* API URL */}
                            <div className='space'>{t('api_url')}</div>
                            {/* API 事件 */}
                            <div className='space merge' style={{ '--lg-column': '4' }}>{t('api_event')}</div>
                            {/* 使用者 IP */}
                            {/* <div className='space'>{t('user_ip')}</div> */}
                            {/* 使用者角色 */}
                            <div className='space'>{t('user_role')}</div>
                            {/* 事件發生時間 */}
                            <div className='space merge' style={{ '--lg-column': '6' }}>{t('event_create_datetime')}</div>
                            {/* 動作 */}
                            <div className='space merge' style={{ '--lg-column': '7' }}>{t('action_type')}</div>
                            {/* 主機 UUID */}
                            <div className='space'>{t('host_uuid')}</div>
                            {/* 使用者名稱 */}
                            <div className='space'>{t('user_name')}</div>
                            <div className='space'>Issuer</div>
                            {/* 使用者主機名稱 */}
                            {/* <div className='space'>{t('user_hostname')}</div> */}
                            {/* 帳號身份別 */}
                            <div className='space'>{t('account_type')}</div>
                        </div>
                        <div className="body">
                            {
                                columns?.length > 0 ? (
                                    <>
                                        {
                                            columns?.map((data, i) => {
                                                return (
                                                  <div className="row" key={i}>
                                                    {/* 軌跡編號 */}
                                                    <div className="space" style={{ "--column": "1" }}>
                                                      <span className="mobile-header">{t("audit_id")}</span>
                                                      <span>{data.auditLongId}</span>
                                                    </div>
                                                    {/* 用戶端帳號 */}
                                                    <div className="space" style={{ "--column": "4" }}>
                                                      <span className="mobile-header">{t("client_id")}</span>
                                                      {/* <div className="d-flex"> */}
                                                      {/* <span className='text-ellipsis'>{data.idToken}</span> */}
                                                      <span>
                                                        <a
                                                          className="text-ellipsis link"
                                                          onClick={() => {
                                                            copyToClipboard(data.idToken);
                                                          }}
                                                        >
                                                          {data.idToken}
                                                        </a>
                                                      </span>
                                                      {/* <Button
                                                                    rounded text
                                                                    type="button"
                                                                    icon="pi pi-copy"
                                                                    onClick={() => { copyToClipboard(data.idToken);}}
                                                                    className='p-button-icon-only'
                                                                >
                                                                </Button> */}

                                                      {/* </div> */}
                                                    </div>
                                                    {/* API URL */}
                                                    <div className="space" style={{ "--column": "5" }}>
                                                      <span className="mobile-header">{t("api_url")}</span>
                                                      <span>{data.apiUrl}</span>
                                                    </div>
                                                    {/* API 事件 */}
                                                    <div
                                                      className="space merge"
                                                      style={{ "--lg-column": "4", "--column": "7" }}
                                                    >
                                                      <span className="mobile-header">{t("api_event")}</span>
                                                      <span>{data?.eventName}</span>
                                                    </div>
                                                    {/* 使用者 IP */}
                                                    {/* <div className='space' style={{ '--column': '8' }}>
                                                            <span className='mobile-header'>{t('user_ip')}</span>
                                                            <span>{!maskView?getMaskedString("name",data?.userIp):data?.userIp}</span>                                                            
                                                        </div> */}
                                                    {/* 使用者角色 */}
                                                    <div className="space" style={{ "--column": "8" }}>
                                                      <span className="mobile-header">{t("user_role")}</span>
                                                      <span>{data.userRole}</span>
                                                    </div>
                                                    {/* 事件發生時間 */}
                                                    <div
                                                      className="space merge"
                                                      style={{ "--lg-column": "6", "--column": "10" }}
                                                    >
                                                      <span className="mobile-header">
                                                        {t("event_create_datetime")}
                                                      </span>
                                                      <span>{data.createDateTime}</span>
                                                    </div>
                                                    {/* 動作 */}
                                                    <div
                                                      className="space merge"
                                                      style={{ "--lg-column": "7", "--column": "11" }}
                                                    >
                                                      <span className="mobile-header">{t("action_type")}</span>
                                                      <Button
                                                        rounded
                                                        text
                                                        severity="secondary"
                                                        className="p-button-icon-only"
                                                        tooltipOptions={{ position: "top" }}
                                                        tooltip={t("button.detail")}
                                                        onClick={() => {
                                                          goItemPage(data);
                                                        }}
                                                      >
                                                        <FontAwesomeIcon icon="fa-solid fa-eye" />
                                                      </Button>
                                                    </div>
                                                    {/* 主機 UUID */}
                                                    <div className="space" style={{ "--column": "2" }}>
                                                      <span className="mobile-header">{t("host_uuid")}</span>
                                                      <span>{data.txnUid}</span>
                                                    </div>
                                                    {/* 使用者名稱 */}
                                                    <div className="space" style={{ "--column": "3" }}>
                                                      <span className="mobile-header">{t("user_name")}</span>
                                                      <span>
                                                        {!maskView
                                                          ? getMaskedString("account", data?.userName)
                                                          : data?.userName}
                                                      </span>
                                                    </div>
                                                    <div className="space" style={{ "--column": "6" }}>
                                                      <span className="mobile-header">Issuer</span>
                                                      {data?.issuer?.split("/")[data?.issuer?.split("/")?.length - 1]}
                                                      <Button
                                                        tooltip={data?.issuer}
                                                        icon="pi pi-info-circle"
                                                        rounded
                                                        text
                                                        size="small"
                                                      ></Button>
                                                    </div>
                                                    {/* 使用者主機名稱 */}
                                                    {/* <div className='space' style={{ '--column': '9' }}>
                                                            <span className='mobile-header'>{t('user_hostname')}</span>
                                                            <span>{!maskView?getMaskedString("name",data?.userHostname):data?.userHostname}</span>                                                            
                                                        </div> */}
                                                    {/* 帳號身份別 */}
                                                    <div className="space marge" style={{ "--column": "9" }}>
                                                      <span className="mobile-header">{t("account_type")}</span>
                                                      <span>{data.acctTypeName}</span>
                                                    </div>
                                                  </div>
                                                );
                                            })
                                        }

                                    </>
                                ) : (
                                    <>
                                        {/* 查無資料顯示這裡 */}
                                        <NoInfo panel="table" />
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className='table-footer'>
                        <span className='font-bold'>{t('row_count')}:{columns?.length}</span>
                        <button style={{ display: columns?.length === 0 ? 'none' : '' }} onClick={() => { btnReadMore(); }} className='btn-more'>{t('button.more')}</button>
                    </div>
                </div>

            </div>
        </div>
    </>)
}
export default AccountActivityIndex;